import { render } from "./SectionConferenceReservation.vue?vue&type=template&id=0700b230&scoped=true"
import script from "./SectionConferenceReservation.vue?vue&type=script&lang=js"
export * from "./SectionConferenceReservation.vue?vue&type=script&lang=js"

import "./SectionConferenceReservation.vue?vue&type=style&index=0&id=0700b230&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0700b230"]])

export default __exports__